const renewalDetailsFormatter = (data, dataKey) => {

  const dataSet = {};
  console.log(data, dataKey, "==================/n/n=======\n\n")
  dataSet[dataKey] = data?.items || []
  return dataSet;
};

  export default renewalDetailsFormatter;
  